import React, { useEffect, useState } from "react";
import GlobalStyles from "../../global/GlobalStyles";
import api from "../../global/api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import SmallLoader from "../loaders/SmallLoader";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PerformanceMetrics = () => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMetrics = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/metrics/monthly");
      setMetrics(data);
    } catch (error) {
      console.error("Error fetching metrics:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMetrics();
  }, []);

  const chartData = {
    labels: metrics?.months || [],
    datasets: [
      {
        label: "Shipments",
        data: metrics?.shipments || [],
        backgroundColor: "#dc2626",
      },
      {
        label: "Deliveries",
        data: metrics?.deliveries || [],
        backgroundColor: "#10b981",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className={`${GlobalStyles.sectionWrap} mt-6`}>
      <h2 className={`${GlobalStyles.sectionHeader} mb-4`}>
        Performance Metrics
      </h2>

      {loading ? (
        <div className="w-full flex justify-center">
          <SmallLoader />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-medium mb-2 text-secondary">
              Monthly Shipments
            </h3>
            <div className="p-4 rounded-lg">
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>

          <div className="space-y-4">
            <div className={`${GlobalStyles.sectionWrap} p-4`}>
              <h3 className="font-medium mb-2 text-secondary">
                On-Time Delivery Rate
              </h3>
              <div className="text-3xl font-bold text-primary">
                {metrics?.on_time_rate || 0}%
              </div>
            </div>

            <div className={`${GlobalStyles.sectionWrap} p-4`}>
              <h3 className="font-medium mb-2 text-secondary">
                Average Delivery Time
              </h3>
              <div className="text-3xl font-bold text-primary">
                {metrics?.avg_delivery_time || 0} days
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PerformanceMetrics;
